import styled from "@emotion/styled";

import AlertIcon from "./icon-alert.svg";

export const Icon = styled(AlertIcon)`
  inline-size: 18px;
  block-size: 18px;
`;
export const Title = styled.div`
  font-weight: 700;
`;
export const Message = styled.div``;

export const Container = styled.a`
  display: grid;
  grid:
    "icon title" max-content
    "icon message" max-content /
    min-content 1fr;
  grid-column-gap: 10px;

  margin-inline: -5px;
  padding: 12px;

  color: #001246;
  line-height: 20px;

  border: 1px solid rgba(235, 66, 84, 0.5);
  border-radius: 2px;

  background: linear-gradient(0deg, rgba(235, 66, 84, 0.05), rgba(235, 66, 84, 0.05)), #ffffff;

  cursor: pointer;

  ${Icon} {
    grid-area: icon;
  }

  ${Title} {
    grid-area: title;
  }

  ${Message} {
    grid-area: message;
  }
`;
